
jQuery(document).ready(function(){
    if (jQuery('.fade_section_con .fade_section').length) {
        var current = 0;
        var num_options = jQuery('.fade_section_con .fade_section').length;
        var freq = 2000;
        var fade_element_array = jQuery('.fade_section_con .fade_section');

        function fadein(x) {
            fade_element_array.eq(x).stop().fadeIn(500);
        }

        function fadeout(x) {
            fade_element_array.eq(x).stop().fadeOut(500, function() {
                jQuery(this).css('opacity', '0');
            });
            
        }

        function fade() {
            fadeout(current);
            current = current + 1;
            if (current >= num_options) {
                current = 0;
            }
            fadein(current);
        }
        setInterval(fade, freq);
    }
});